import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}`;

export const getProfile = (guildId) => apiRequest(`${base(guildId)}/profile`);
export const updateProfile = (guildId, payload) =>
  apiRequest(`${base(guildId)}/profile`, { method: "PATCH", body: payload });
export const resetProfile = (guildId) =>
  apiRequest(`${base(guildId)}/profile/reset`, { method: "POST" });
